import {MenuProps} from "antd";
import {ReactNode} from "react";

export enum colTypeOptions {
    text = 'text',
    number = 'number',
    date = 'date',
    percent = 'percent',
    usd = 'usd',
}

export enum filterTypeOptions {
    text = 'text',
    number = 'number',
    date = 'date',
    percent = 'percent',
    usd = 'usd',
    textToId = 'textToId',
    textToKey = 'textToKey'
}

export enum sortingDirectionOptions {
    DESC = 'DESC',
    ASC = 'ASC'
}

export interface ColProps {
    key: string;
    name: string;
    type: colTypeOptions;
    width?: number;
    maxWidth?: number;
    paddingLeft?: number;
    isPinned?: boolean;
    render?: (value: any, row?: any, reFetch?: () => void) => ReactNode | ReactNode[] | string | number;
}

export interface FilterProps {
    filterKey: string;
    name: string;
    type: filterTypeOptions;
    min?: number | Date;
    max?: number | Date;
    from?: Date;
    to?: Date;
    options?: MenuProps['items'];
    allLabel?: string;
    selected?: number | string | null;
    value?: string | number;
}

export interface FetchProps {
    selectedDomain: string;
    filters: any;
    sortingBy: string;
    sortingDirection: sortingDirectionOptions;
    limit?: number;
    offset?: number;
    isCsvCall?: boolean;
    page?: number;
    pageSize?: number;
}

export interface TableProps {
    fetch: ({ filters, sortingBy, sortingDirection, page, pageSize }: FetchProps) => any;
    cols: ColProps[];
    title?: string;
    filters?: FilterProps[];
    showSearch?: boolean;
    doneLoadingDependencies?: boolean;
    filterLocally?: (rows: any[], filters: FilterProps[]) => any[];
    onRowClick?: (row: any) => void;
}

export interface TableHeadProps {
    cols: ColProps[];
    title?: string;
    showSearch?: boolean;
    exportToExcel: () => void;
}

export interface TableContentProps {
    cols: ColProps[];
    data: any;
    reFetch?: () => void;
    onRowClick?: (row: any) => void;
}